var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-loader',{attrs:{"loading":_vm.loading}}):_c('v-meta',{attrs:{"meta":_vm.meta,"do-px":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }